import { differenceInMinutes, differenceInSeconds } from 'date-fns';

import { IUserOrderFragment, RbiOrderStatus } from 'generated/rbi-graphql';

import { MAX_MINUTES_ORDER_CHECK, MIN_SECONDS_WAIT_AFTER_EXITING } from './constants';

interface IGetOrderInProgressOptions {
  dateNow: Date;
  order?: IUserOrderFragment | null;
  allowedStatuses: RbiOrderStatus[];
  lastQueueExitTimestamp?: Date;
}

export const getOrderInProgress = ({
  dateNow,
  order,
  allowedStatuses,
  lastQueueExitTimestamp,
}: IGetOrderInProgressOptions) => {
  if (!order?.status || !allowedStatuses.includes(order?.status)) {
    return null;
  }

  const createdAtDate = new Date(order.createdAt);

  // ignore order if it has just the queue too recently
  // e.g. the BE might not be updated yet with a terminal status,
  // but we want to prevent the FE from still showing the banner.
  if (
    lastQueueExitTimestamp &&
    differenceInSeconds(dateNow, lastQueueExitTimestamp) < MIN_SECONDS_WAIT_AFTER_EXITING
  ) {
    return null;
  }

  // ignore order if it was created too long ago
  if (differenceInMinutes(dateNow, createdAtDate) > MAX_MINUTES_ORDER_CHECK) {
    return null;
  }

  return order;
};

export interface ITrackingBannerDetailsModalProps {
  setShowDetails: (showDetails: boolean) => void;
  rbiOrderId: string;
}
